module.exports = __webpack_public_path__ + "assets/img/1_545.fdd088f9.jpg";